import Image from "next/image";
import Link from "next/link";
import styles from './styles.module.scss';
const formatClassName = (title) => {
    return title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '-');
};
const Slide = ({ details, heroImage, mobileHeroImage, animate, title }) => {
    const { headline, copy, cta } = details || {};
    const { mediaItemUrl, mediaDetails, altText } = heroImage?.node || {};

    return (
        <div className={styles.brandHero__slide}>
            <div className={`${styles.brandHero__content}`}>
                <h1 className={`${styles.brandHero__headline} ${animate ? 'animateHeadline' : ''}`}>
                    {headline}
                </h1>
                <div 
                    className={`${styles.brandHero__copy} ${animate ? 'animateCopy' : ''}`} 
                    dangerouslySetInnerHTML={{ __html: copy || ' ' }}
                />
                <Link href={cta?.url || '#'} className={`${styles.brandHero__cta} button primary-fill regular ${animate ? styles.animateCta : ''}`}>
                    {cta?.title}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#D41050"/>
                    </svg>
                </Link>
            </div>
            <div className={`${styles.brandHero__image} ${formatClassName(title || '')}`}>
                <Image
                    className={`${styles.brandHero__desktopImage} ${animate ? 'animateOn': ''}`}
                    loading={'eager'} 
                    priority
                    src={mediaItemUrl || '/content_hero_fallback.png'} 
                    width={mediaDetails?.width || 1400} 
                    height={mediaDetails?.height || 1400} 
                    alt={altText || headline}
                />
                <Image
                    className={styles.brandHero__mobileImage}
                    loading={'eager'} 
                    priority
                    src={mobileHeroImage?.node?.mediaItemUrl || '/content_hero_fallback.png'} 
                    width={mobileHeroImage?.node?.mediaDetails?.width || 1080} 
                    height={mobileHeroImage?.node?.mediaDetails?.height || 1920} 
                    alt={mobileHeroImage?.node?.altText || headline}
                />
            </div>
        </div>
    );
}

export default Slide;
